import { ProductCondition } from '../types';

/**
 * Same keys as sidebar condition options (SidebarFilterAdminService SyncConditionOptionsAsync):
 * `filter.condition.{New|LikeNew|Good|Fair|Poor}`
 */
export function productConditionTranslationKey(
    condition: ProductCondition | string | null | undefined
): string {
    const value = String(condition ?? '').trim();
    return value ? `filter.condition.${value}` : 'filter.condition';
}

/** English fallbacks matching SeedCompleteTranslations (not camelCase enum dumps). */
const CONDITION_FALLBACKS: Record<string, string> = {
    New: 'New',
    LikeNew: 'Like New',
    Good: 'Good',
    Fair: 'Fair',
    Poor: 'Poor',
};

export function productConditionFallback(
    condition: ProductCondition | string | null | undefined
): string {
    const value = String(condition ?? '').trim();
    if (!value) return '';
    if (CONDITION_FALLBACKS[value]) return CONDITION_FALLBACKS[value];
    // e.g. VeryGood → Very Good if enum grows without seed update
    return value.replace(/([a-z])([A-Z])/g, '$1 $2');
}

/** Resolve label via shop i18n + shared key contract. */
export function translateProductCondition(
    tr: (key: string, fallback: string) => string,
    condition: ProductCondition | string | null | undefined
): string {
    const value = String(condition ?? '').trim();
    if (!value) return '';
    return tr(productConditionTranslationKey(value), productConditionFallback(value));
}
